namespace GeniuzPOS.InitialData {
    export class PsDebitCardColumns {
        static columnsKey = 'InitialData.PsDebitCard';
    }
}
